export default {
  methods: {
    /**
     * 解析加密数据
     * @param {string} type 类型：身份证1、银行卡号2、手机号3、邮箱4、地址5
     * @param {string} token 解密token
     */
    decodeByToken(type, token) {
      return new Promise((resolve) => {
        this.fetch.post('decodeByToken', { token, type }).then((res) => resolve(res.text))
      })
    },

    handleDecodeInfo(decodeEnum = [], cb) {
      console.warn('handleDecodeInfo', decodeEnum, cb)
      decodeEnum.forEach(({ type, token, key }) => {
        if (!type || !token) return
        this.decodeByToken(type, token).then((text) => {
          cb && cb(key, text)
        })
      })
    },
  },
}
